<template>
  <div>
    <q-dialog :visible="dialogVisible" :title="dialogTitle" width="640px" :innerScroll="false" :showFooter="false" @cancel="onCancel" @close="onCancel">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" style="padding: 20px 0">
        <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" size="mini" class="content">
          <el-row>
            <el-col :span="24" v-if="mode !== 'delete'">
              <el-form-item label="上传路径:">
                <span>{{ folderPath }}</span>
              </el-form-item>
            </el-col>
            <!-- 删除模式提示信息 -->
            <el-col :span="24" v-if="mode === 'delete'" class="delete-tips">
              <div class="delete-confirm-text">确认删除后将删除当前文件夹，是否确认删除？</div>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否通知:" prop="isNotify">
                <el-radio-group v-model="formData.isNotify">
                  <el-radio :label="1">需要通知</el-radio>
                  <el-radio :label="0">无需通知</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 删除模式红色提示 -->
              <div v-if="mode === 'delete'" class="delete-notify-tip">确认删除后，需要通知则系统会给店铺发送"通栏图删除下架"消息通知</div>
            </el-col>
            <el-col :span="24" v-if="formData.isNotify === 1">
              <el-form-item :label="mode === 'delete' ? '调整详细说明:' : '详细说明:'" prop="adjustDetailDesc" class="required-item">
                <div ref="editorRef" class="editor-container"></div>
              </el-form-item>
            </el-col>
            <!-- 附件上传 - 删除模式下隐藏 -->
            <el-col :span="24" align="left" v-if="mode !== 'delete'">
              <el-form-item label="附件:" class="upload-demo required-item">
                <el-upload
                  accept=".jpg,.jpeg,.png,.gif"
                  ref="upload"
                  multiple
                  :disabled="disabled"
                  :limit="999"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary" @click="importFile">选取文件夹</el-button>
                  <el-button type="text" style="color: red" size="mini" @click="clearFile">一键清空</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传图片文件，可批量上传</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="formData.isNotify === 1">
              <el-form-item label="清单:" prop="listType" class="required-item">
                <el-radio-group v-model="formData.listType">
                  <el-radio :label="1">手动输入</el-radio>
                  <el-radio :label="2">批量导入</el-radio>
                </el-radio-group>
                <div class="list-input-container">
                  <el-input
                    v-if="formData.listType === 1"
                    type="textarea"
                    v-model="formData.listContent"
                    :rows="4"
                    placeholder=""
                  ></el-input>
                  <!-- <el-upload v-else action="" accept=".xlsx,.xls" :auto-upload="false" :on-change="handleExcelChange" :file-list="excelFileList" :limit="1"> -->
                  <el-upload v-else action="" accept="" :auto-upload="false" :on-change="handleExcelChange" :file-list="excelFileList" :limit="1">
                    <el-button size="small" type="primary">请上传需调整产品清单</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center; margin-top: 20px">
          <el-button @click="onCancel" size="medium">取消</el-button>
          <el-button type="primary" class="green-btn" @click="onConfirm" size="medium">确定</el-button>
        </div>
      </div>
    </q-dialog>

    <!-- 通知店铺弹窗 -->
    <notify-store-dialog :visible.sync="notifyDialogVisible" @confirm="handleNotifyConfirm" />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import E from 'wangeditor';
import NotifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog.vue';

export default {
  name: 'uploadBannerDialog',
  components: {
    NotifyStoreDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 上传路径，由父组件传入
    folderPath: {
      type: String,
      default: '',
    },
    folderId: {
      type: [String, Number],
      default: '',
    },
    rowId: {
      type: [String, Number],
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '上传通栏图',
    },
    // 模式: upload-上传, edit-修改, delete-删除
    mode: {
      type: String,
      default: 'upload',
    },
    folderPath: {
      type: String,
      default: '',
    },
    fileType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        isNotify: 1,
        adjustDetailDesc: '',
        listType: 1,
        listContent: '',
      },
      rules: {
        isNotify: [{ required: true, message: '请选择是否通知', trigger: 'change' }],
        listType: [{ required: true, message: '请选择清单类型', trigger: 'change' }],
      },
      fileList: [],
      fileListAll: [],
      excelFileList: [],
      editor: null,
      htmlImgList: [],
      notifyDialogVisible: false,
      disabled: false,
      folderName: '',
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  watch: {
    'formData.isNotify'(val) {
      // 切换到需要通知时，重新初始化富文本编辑器
      if (val === 1) {
        this.$nextTick(() => {
          this.destroyEditor();
          this.initEditor();
        });
      }
      this.$nextTick(() => {
        this.initUpload();
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initUpload();
      this.initEditor();
    });
  },
  methods: {
    initUpload() {
      this.$nextTick(() => {
        if (this.$refs.upload && this.$refs.upload.$children[0] && this.$refs.upload.$children[0].$refs.input) {
          this.$refs.upload.$children[0].$refs.input.webkitdirectory = true;
        }
      });
    },
    initEditor() {
      let _this = this;
      setTimeout(() => {
        let editor2 = new E(this.$refs.editorRef);
        editor2.config.menus = [
          'image', // 插入图片
        ];

        editor2.config.onchange = (html) => {
          this.formData.adjustDetailDesc = html + '';
          this.htmlImgList = this.htmlImgList.filter((v) => this.formData.adjustDetailDesc.includes(v));
        };
        editor2.config.placeholder = '';
        editor2.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
        editor2.config.uploadFileName = 'file'; //后端接受上传文件的参数名
        editor2.config.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
        editor2.config.uploadVideoAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
        editor2.config.showLinkImg = false; //隐藏网络图片上传
        editor2.config.maxLength = 500; //最大输入

        editor2.config.uploadImgHeaders = {
          'Access-Control-Allow-Origin': 'origin',
          Authorization: getToken,
        };
        editor2.config.customUploadImg = async (files, insert) => {
          if (this.htmlImgList.length == 5) {
            this.$message.error('最多上传五张图片！');
            return;
          }
          const form = new FormData();
          form.append('file', files[0]);
          form.append('appCode', 'ec-pc-api');
          fetch('https://upload.quanyou.com.cn/gw/qu-file-upload-api/upload/app/uploadFile', {
            method: 'POST',
            body: form,
            mode: 'cors',
          })
            .then((response) => response.json())
            .then((res) => {
              if (res.success) {
                this.htmlImgList.push(res.data.fileUrl);
                insert(res.data.fileUrl);
              } else {
                this.$message.error(res.message);
              }
            });
        };
        editor2.create();
        editor2.txt.html('<p></p>');
        this.editor = editor2;
      }, 500);
    },
    destroyEditor() {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
    importFile() {
      if (this.fileList.length) {
        this.$message.error('一次仅上传一个文件夹');
        this.disabled = true;
        setTimeout(() => {
          this.disabled = false;
        }, 20);
        return;
      }
    },
    httpRequest() {},
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload(file) {
      let pathText = file.webkitRelativePath;
      this.folderName = pathText.split('/')[0];
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (pattern !== 'db' && pattern !== 'ds_store') {
        this.fileListAll.push(file);
        // 使用临时数组收集文件，避免与 el-upload 组件产生竞态
        if (!this._pendingFiles) {
          this._pendingFiles = [];
        }
        this._pendingFiles.push(file);
        // 使用防抖，等所有文件处理完毕后统一更新 fileList
        if (this._uploadTimer) {
          clearTimeout(this._uploadTimer);
        }
        this._uploadTimer = setTimeout(() => {
          if (this._pendingFiles && this._pendingFiles.length > 0) {
            this.fileList = [...this._pendingFiles];
            this._pendingFiles = [];
          }
        }, 100);
      }
      return false;
    },
    clearFile() {
      this.fileList = [];
      this.fileListAll = [];
      this._pendingFiles = [];
      if (this._uploadTimer) {
        clearTimeout(this._uploadTimer);
        this._uploadTimer = null;
      }
    },
    handleExcelChange(file, fileList) {
      this.excelFileList = fileList.slice(-1);
    },
    onCancel() {
      this.resetForm();
      this.dialogVisible = false;
    },
    resetForm() {
      this.formData = {
        isNotify: 1,
        adjustDetailDesc: '',
        listType: 1,
        listContent: '',
      };
      this.fileList = [];
      this.fileListAll = [];
      this.excelFileList = [];
      this.htmlImgList = [];
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.$message.error('请填写必填项');
          return;
        }
        // 删除模式不需要验证附件
        if (this.mode !== 'delete' && !this.fileList.length) {
          this.$message.error('请选择上传的文件夹');
          return;
        }
        // 如果需要通知，则弹出通知店铺弹窗
        if (this.formData.isNotify === 1) {
          // 如果选择了批量导入，校验清单文件必传
          if (this.formData.listType === 2 && !this.excelFileList.length) {
            this.$message.error('请上传需调整产品清单');
            return;
          }
          this.notifyDialogVisible = true;
        } else {
          // 无需通知，直接上传
          this.submitUpload();
        }
      });
    },
    // 处理通知弹窗确认回调
    handleNotifyConfirm(notifyData) {
      // 将通知参数合并到表单数据中，然后提交
      this.submitUpload(notifyData);
    },
    async submitUpload(notifyData = null) {
      const loading = this.$loading({
          lock: true,
          text: '操作处理中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
      try {
        let picAdjustType = this.dialogTitle.includes('上传') ? '新增' : this.dialogTitle.includes('修改') ? '修改' : '删除';
        var data = {
          ...notifyData,
          adjustDetailDesc: this.formData.adjustDetailDesc,
          listContent: this.formData.listContent,
          folderName: this.folderName,
          adjustContent: '通栏图',
          picAdjustType,
        };
        const formData = new FormData();
        if (this.excelFileList.length > 0) {
          const listFile = this.excelFileList[0].raw || this.excelFileList[0];
          formData.append('listFile', listFile);
        }
        //新增编辑模式
        if (['新增', '修改'].includes(picAdjustType)) {
          this.fileList.forEach((file) => {
            formData.append('files', file.raw || file);
          });
          formData.append('folderId', picAdjustType == '新增' ? this.folderId : this.rowId);
          formData.append('folderName', this.folderName);
          picAdjustType == '修改' && formData.append('type', this.fileType);
          //删除模式
        } else {
          // delete data.adjustDetailDesc
          // delete data.listContent
          formData.append('id', this.rowId);
          formData.append('type', this.fileType);
        }
        // 如果有通知参数，追加到表单数据中
        if (notifyData) {
          formData.append('msgNotice', JSON.stringify(data));
        }
        let res;
        if (picAdjustType === '新增') {
          res = await this.$q.newProduct.fullWidthBatchUpload({ data: formData });
        } else if (picAdjustType === '删除') {
          res = await this.$q.newProduct.fullWidthDeleteFolder({ data: formData });
        } else if (picAdjustType === '修改') {
          res = await this.$q.newProduct.fullWidthBatchUploadUpdate({ data: formData });
        }
        if(picAdjustType === '删除' && res.success) {
          this.$message.success('删除成功');
          this.dialogVisible = false;
          this.$emit('complete'); 
          loading.close();
          return
        }
        const _this = this;
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.data] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                clearInterval(timer);
                loading.close();
                if (res.data.taskResult == '成功') {
                  _this.$message.success('操作成功');
                  _this.dialogVisible = false;
                  _this.$emit('complete'); 
                } else {
                  _this.$message.error(res.data.failReason);
                }
              }
            })
            .finally(() => {
              loading.close();
            });
        }, 5000);
      } catch (error) {
        loading.close();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.content
  padding 0 20px
  max-height 70vh
  overflow-y auto

.list-input-container
  margin-top 10px

.required-item
  >>> .el-form-item__label::before
    content '*'
    color #F56C6C
    margin-right 4px

.upload-demo
  >>> .el-upload-list
    max-height 150px
    overflow-y auto

>>> .el-dialog
  margin-top 50px !important

// 删除模式样式
.delete-tips
  padding 0 20px
  margin-bottom 10px

.delete-confirm-text
  font-size 14px
  color #333
  padding 10px 0

.delete-notify-tip
  color #F56C6C
  font-size 12px
  margin-top 5px
  padding-left 100px
</style>

<style lang="stylus">
/* 编辑器样式需要放在非scoped中才能生效 */
.editor-container
  border 1px solid #ccc
  min-height 150px
  position relative
  .w-e-toolbar
    border-bottom 1px solid #ccc
    background-color #f1f1f1
  .w-e-text-container
    min-height 120px
    .w-e-text
      min-height 100px
      padding 10px
</style>
